// extracted by mini-css-extract-plugin
module.exports = {"tabsWrapper":"styles_tabsWrapper__384-G","tab":"styles_tab__1DQdS","activeTab":"styles_activeTab__3KNyK","slideInFromRight":"styles_slideInFromRight__PDTke"};